import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import SystemNamedLocationsList from '../../components/system/SystemNamedLocations/SystemNamedLocationsList';
import SystemNamedLocationsHeader from '../../components/system/SystemNamedLocations/SystemNamedLocationsHeader';

import { useSessionContext } from '../../contexts/SessionContext';

export default function SystemNamedLocationsPage( props ){
    //console.debug("RTS Break SystemNamedLocationsPage");

    const {userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [data, setData] = useState([]);

  
    const fetchData = useCallback((pFilter) => {
        let apiURL = apiRoot + "/NamedLocations/GetLocationsGlobal";
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]);

    
    useEffect(() => {
        props.setIsModalFx(false);
        fetchData();
    }, [props, fetchData]);  
    

    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <Box>
            <SystemNamedLocationsHeader />
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <SystemNamedLocationsList data={data} />
            </Box>
        </Box>
    );
}
